//import React from 'react';
//import { EyeOff } from "lucide-react";
//import { Skull } from "lucide-react";
import { FaSkullCrossbones } from "react-icons/fa6";
//import { RiPaintBrushFill } from "react-icons/ri";
import { ImPaintFormat } from "react-icons/im";
//import { ReactComponent as Skull } from '../../assets/skull_invertB.svg';
import "./ImageCell.css";
const ImageCellDead = ({ /*onClick, */ bgColor, statut = "x" }) => {
  const dead = statut === "x";

  return dead ? (
    <button
      className={"image-action-btn-dead"}
      //className={`image-action-btn ${dead ? "dead" : "-notdead"}`}
      //style={{ backgroundColor: dead ? bgColor : bgColor,}}
      // onClick={onClick}
      title="disparu"
      //style={{ backgroundColor: bgColor }}
    >
      <FaSkullCrossbones
        size={16}
        strokeWidth={2}
        //  className="skull-icon"
      />
    </button>
  ) : (
    <button className={"image-action-btn-notdead"} title="modifié et/ou endommagé">
      <ImPaintFormat
        size={16}
        strokeWidth={0}
        //  className="skull-icon"
      />
    </button>
  );
};

export default ImageCellDead;

/*
// <Bone />
// <Ghost />
// <Skull />
// <CircleX />
<EyeOff />
// dodomomo_octo/public/assets/skull_invert.svg

*/
